import { useEffect, useState } from 'react';

import isEqual from 'lodash/isEqual';

import { sidebar, SideBarItemType } from '~/core/sidebar';
import { useAppSelector } from '~/store/hooks/useAppSelector';

export const useMainLayoutSidebarGroups = (): SideBarItemType[][] => {
  const profile = useAppSelector(
    (state) => state.profile,
    (state1, state2) => !isEqual(state1, state2),
  );
  const [sidebarGroups, setSidebarGroups] = useState<SideBarItemType[][]>(() =>
    Object.values(sidebar.getAvailableItems(profile)),
  );

  useEffect(() => {
    const syncSidebarGroups = (): void => {
      setSidebarGroups(Object.values(sidebar.getAvailableItems(profile)));
    };
    const unsubscribe = sidebar.subscribe(syncSidebarGroups);

    syncSidebarGroups();

    return (): void => {
      unsubscribe();
    };
  }, [profile]);

  return sidebarGroups;
};
